import { ActivityTaskTypeEnum } from './activity-task-type-enum'

export interface ActivityTaskInterface {
  /**
   * 活动任务名
   */
  name: string
  /**
   * 活动类型
   */
  type: ActivityTaskTypeEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class ActivityTask implements ActivityTaskInterface {
  /**
   * 活动任务名
   */
  name: string
  /**
   * 活动类型
   */
  type: ActivityTaskTypeEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: ActivityTaskInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      type: _type,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.type = _type
    this.id = _id
    this.schoolId = _schoolId
  }
}
